import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { createStyles, HawkinsGlobalClass, makeStyles } from '@hawkins/styles';
var styleResetStyles = function (theme) {
    var _a, _b;
    var hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        '@global': (_a = {
                html: {
                    boxSizing: 'border-box',
                },
                '*, *::before, *::after': {
                    boxSizing: 'inherit',
                }
            },
            _a[".".concat(HawkinsGlobalClass.FOCUSABLE)] = (_b = {},
                _b["&:not(:focus-visible):not(.".concat(HawkinsGlobalClass.FOCUS_RING, ")")] = { outline: 'none' },
                _b[hawkinsUtils.getFocusRingedElementSelector('&')] = hawkinsUtils.getFocusRingedElementStyle(),
                _b),
            // Hides an element both visually AND from screen readers.
            _a[".".concat(HawkinsGlobalClass.HIDDEN)] = {
                visibility: 'hidden',
            },
            _a[".".concat(HawkinsGlobalClass.ICON)] = {
                height: hawkinsVariables.sizings.size2,
                fill: 'currentColor',
                flexShrink: 0,
            },
            _a[".".concat(HawkinsGlobalClass.ICON_SMALL)] = {
                height: hawkinsVariables.sizings.size1,
            },
            // Truncate overflowing text with an ellipsis.
            _a[".".concat(HawkinsGlobalClass.TRUNCATE)] = {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
            _a),
    });
};
var useStyleReset = makeStyles(styleResetStyles, { name: 'Hawkins-CSSReset' });
/**
 * Style reset for all Hawkins components, theme agnostic styles that need to be applied to
 * ensure that Hawkins components render properly.
 *
 * This is provided by default because these styles are REQUIRED!
 */
export var CSSReset = function () {
    useStyleReset();
    return _jsx(React.Fragment, {});
};
CSSReset.displayName = 'CSSReset';
